// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__Ufe1I","accentTheme":"skeleton_accentTheme__MKg4_"};